import React from "react";
import { TRANSLATION_KEYS as T } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { Toggle } from "@cadenza/ui";
import { useEditorPreferences } from "./EditorPreferencesProvider";

import "./EditorPreferencePanel.css";

/**
 * Editor preferences panel with toggles for various editor settings
 * Uses EditorPreferencesProvider for state management and persistence
 * @param {Object} props
 * @param {Function} props.onClose - Function to call when closing the panel
 * @returns {JSX.Element}
 */
const EditorPreferencesPanel = ({ onClose }) => {
  const { STRINGS = {} } = useLanguageContext() || {};
  const { preferences, updatePreference } = useEditorPreferences();

  const EDITOR_PREFERENCES = STRINGS[T.EDITORPREFS] || "Editor Preferences";
  const SHOW_ICON_LABELS = "Show Icon Labels"; // Could add this to translations later

  const handleToggleIconLabels = (isOn) => {
    updatePreference("showIconLabels", isOn);
  };

  return (
    <div className="editor-preferences-panel" role="dialog" aria-modal="true">
      <div className="editor-preferences-title-bar">
        <h3>{EDITOR_PREFERENCES}</h3>
        <button
          className="editor-preferences-close"
          aria-label="Close editor preferences"
          onClick={onClose}
        >
          &times;
        </button>
      </div>

      <div className="editor-preference-value">
        <span>{SHOW_ICON_LABELS}</span>
        <Toggle
          isOn={preferences.showIconLabels}
          onToggle={handleToggleIconLabels}
          onLabel="Show"
          offLabel="Hide"
          size="medium"
          variant="primary"
        />
      </div>

      {/* <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
        <button
          onClick={handleReset}
          style={{
            padding: "8px 16px",
            backgroundColor: "var(--secondary-color, #6c757d)",
            color: "",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          {RESET}
        </button>
        <button
          onClick={onClose}
          style={{
            padding: "8px 16px",
            backgroundColor: "var(--primary-color, #007bff)",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          {CLOSE}
        </button>
      </div> */}
    </div>
  );
};

export default EditorPreferencesPanel;
